// Season configuration for managing different competitive seasons
// Each season has a date range and its own map pool

export const SEASONS = {
  '2025': {
    name: '2025 Season',
    startDate: '2025-01-01',
    endDate: '2025-12-31',
    isActive: false,
    mapPools: {
      HP: ['Summit', 'Apocalypse', 'Hacienda', 'Slums', 'Combine'],
      SND: ['Tunisia', 'Firing Range', 'Kurohana Metropolis', 'Standoff', 'Coastal'],
      CTL: ['Raid', 'Takeoff', 'Crossfire']
    }
  },
  '2026': {
    name: '2026 Season',
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    isActive: true,
    mapPools: {
      HP: ['Summit', 'Hacienda', 'Takeoff', 'Arsenal', 'Combine'],
      SND: ['Tunisia', 'Firing Range', 'Slums', 'Meltdown', 'Coastal'],
      CTL: ['Raid', 'Standoff', 'Crossroads']
    }
  }
};

// Get season for a given date
export const getSeasonForDate = (dateString) => {
  if (!dateString) return null;
  
  const date = new Date(dateString);
  
  for (const [seasonKey, season] of Object.entries(SEASONS)) {
    const start = new Date(season.startDate);
    const end = new Date(season.endDate);
    
    if (date >= start && date <= end) {
      return seasonKey;
    }
  }
  
  return String(date.getFullYear());
};

// Get current active season
export const getCurrentSeason = () => {
  const currentYear = String(new Date().getFullYear());
  if (SEASONS[currentYear]) return currentYear;
  return Object.entries(SEASONS).find(([_, season]) => season.isActive)?.[0] || currentYear;
};

// Get all available seasons
export const getAvailableSeasons = () => {
  const years = new Set(Object.keys(SEASONS));
  years.add(getCurrentSeason());
  return Array.from(years).sort().reverse(); // Most recent first
};

// Get map pool for a specific season and mode
export const getMapPoolForSeason = (season, mode) => {
  const direct = SEASONS[season];
  if (direct) return direct.mapPools[mode] || [];

  // Future-proof fallback: if this year isn't configured yet,
  // use the latest configured season map pool.
  const latestConfigured = Object.keys(SEASONS).sort().reverse()[0];
  if (!latestConfigured) return [];
  return SEASONS[latestConfigured]?.mapPools?.[mode] || [];
};

// Get all maps across all seasons for a mode
export const getAllMapsForMode = (mode) => {
  const allMaps = new Set();
  Object.values(SEASONS).forEach(season => {
    (season.mapPools[mode] || []).forEach(map => allMaps.add(map));
  });
  return Array.from(allMaps).sort();
};

export default SEASONS;

